import MSOStyle from './parseMS/parseMSOCss';
import TablePasteParser from './TablePasteParser';
import TextPasteParser from './TextPasteParser';
import { defaultStyleString } from './ParserUtils';
import { IShapeData } from '@tencent/slide-sdk-model';

export default class PPTPasteParser {
    public static instance: PPTPasteParser;
    public static getSingleton = () => {
        if (!PPTPasteParser.instance) {
            PPTPasteParser.instance = new PPTPasteParser();
        }
        return PPTPasteParser.instance;
    };

    public mSOStyle: any;

    public parse(res, style, parsePasteHTML) {
        try {
            let styleHtml = defaultStyleString();
            if (style) {
                styleHtml = style.outerHTML;
            }
            this.mSOStyle = new MSOStyle(styleHtml);
        } catch (e) {
            const styleHtml = defaultStyleString();
            this.mSOStyle = new MSOStyle(styleHtml);
        } finally {
            // 初始化text parser
            TextPasteParser.getSingleton().initParser(this.mSOStyle);
            // 初始化table parser
            TablePasteParser.getSingleton().initParser(this.mSOStyle);
        }

        const richTextData: IShapeData[] = [];
        const tableData: any = [];

        // text的数据转sdk数据
        if (res.nodes && res.nodes.length > 0) {
            const textSDKData = TextPasteParser.getSingleton().parseNodesToSdkData(res.nodes);
            richTextData.push(textSDKData);
        }

        // table的数据转sdk数据 （可能存在多个）
        res.table.forEach((table) => {
            const tableSDkData = TablePasteParser.getSingleton().parseTableNodeToSdkData(table, parsePasteHTML);
            if (tableSDkData) {
                tableData.push(tableSDkData);
            }
        });

        return {
            richTextData, tableData,
        };
    }
}
